import SliceNames from '@/state/enum';
import { IStore, SetState } from '@/state/slices/typings';
import { WindowActions } from '@/state/slices/window/typings';

const windowActionsCreator = (set: SetState<IStore>): WindowActions => {
	return {
		[SliceNames.WINDOW]: {
			setSize: (width, height) => {
				set(
					(state) => ({
						...state,
						[SliceNames.WINDOW]: {
							...state[SliceNames.WINDOW],
							width,
							height,
						},
					}),
					undefined,
					{
						type: `${SliceNames.WINDOW}/setSize`,
						width,
						height,
					},
				);
			},
		},
	};
};

export default windowActionsCreator;
